import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const localeLoaders = {
  en: () => import('./locales/en/translation.json'),
  id: () => import('./locales/id/translation.json')
};

const localeBackend = {
  type: 'backend' as const,
  read: (
    language: string,
    _namespace: string,
    callback: (error: Error | null, translations: unknown) => void
  ) => {
    const loadLocale = localeLoaders[language as keyof typeof localeLoaders];

    if (!loadLocale) {
      callback(new Error(`Unsupported language: ${language}`), null);
      return;
    }

    loadLocale()
      .then(({ default: translations }) => callback(null, translations))
      .catch((error: Error) => callback(error, null));
  }
};

i18n
  .use(localeBackend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    supportedLngs: Object.keys(localeLoaders),
    load: 'languageOnly',
    fallbackLng: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
